import { ISubscriptionPaymentSummary } from 'fitbeat.models';
import moment from 'moment-timezone';
import React, { PureComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Theme from '../../theme';
import { defaultScale } from '../../utils';
import { getPerIntervalText, styles } from './SubscriptionSummary';

interface IProps {
  t: (key: string, options?: any) => string;
  total: number;
  paymentSubscriptionSummary: ISubscriptionPaymentSummary;
  billingStartDate: string;
}

export default class SpecialOfferSubscriptionSummary extends PureComponent<IProps> {

  public render() {
    const { paymentSubscriptionSummary, t, billingStartDate, total } = this.props;
    const subheaderAndStartDateText = this.getSubheaderAndStartDateText();
    const formattedBillingStartDate = new moment(billingStartDate).format('DD MMM YYYY');
    return (
      <>
        <View style={styles.headingContainer}>
          <Text style={Theme.textStyle.heading}>
            {paymentSubscriptionSummary.paymentMethodRequired ?
              t('specialOfferHeadingIfPaymentDetailsRequired') : t('specialOfferHeadingIfPaymentDetailsNotRequired')}
          </Text>

          <Text style={localStyles.subHeader}>
            {subheaderAndStartDateText.subHeader}
          </Text>
        </View>

        <View style={styles.row}>
          <View style={styles.rowTextContainer}>
            <Text style={Theme.textStyle.bodyCopyReg}>{subheaderAndStartDateText.billingStartText}</Text>
          </View>
          <View style={styles.rowValueContainer}>
            <Text style={Theme.textStyle.bodyCopyReg}>{formattedBillingStartDate}</Text>
          </View>
        </View>

        <View style={[styles.row, { borderTopWidth: 0, paddingTop: 0 }]}>
          <View style={styles.rowTextContainer}>
            <Text style={Theme.textStyle.bodyCopyReg}>{paymentSubscriptionSummary.name}</Text>
          </View>
          <View style={styles.rowValueContainer}>

            {paymentSubscriptionSummary.coupon &&
              <Text style={styles.boldReg}>
                <Text style={localStyles.preDiscountValue}>
                  {paymentSubscriptionSummary.currencySymbol}{paymentSubscriptionSummary.amount}</Text>
                {'  '}{paymentSubscriptionSummary.currencySymbol}{total.toString(10)}
              </Text>
            }

            {!paymentSubscriptionSummary.coupon &&
              <Text style={styles.boldReg}>
                ${total.toString(10)}
              </Text>
            }

            <Text style={styles.small}>
              {getPerIntervalText(paymentSubscriptionSummary)}
            </Text>
          </View>
        </View>

        <View style={styles.row}>
          <View style={styles.rowTextContainer}>
            <Text style={styles.totalText}>{t('totalDueToday')}</Text>
          </View>
          <View style={styles.rowValueContainer}>
            <Text style={styles.totalText}>{paymentSubscriptionSummary.currencySymbol}0</Text>
          </View>
        </View>
      </>
    );
  }

  private getSubheaderAndStartDateText = () => {
    const { paymentSubscriptionSummary, t } = this.props;
    const userCurrenStatus = paymentSubscriptionSummary.accountStatusChangeValidation?.fromStatus;
    if (userCurrenStatus === 'InStudioTrial') {
      return {
        subHeader: t('specialOfferSubheaderBillingStartAfterTrial'),
        billingStartText: t('specialOfferBillingStartAfterTrial'),
      };
    }
    if (userCurrenStatus === 'NoActiveSubscription') {
      return {
        subHeader: t('specialOfferSubheaderBillingStartAfterFreeAccess'),
        billingStartText: t('specialOfferBillingStartAfterFreeAccess'),
      };
    }
    return {
      subHeader: t('specialOfferSubheaderBillingStartsAfterStandardPlan'),
      billingStartText: t('specialOfferBillingStartsAfterStandardPlan'),
    };
  }

}

const localStyles = StyleSheet.create({
  subHeader: {
    ...Theme.textStyle.bodyCopyBold,
    marginTop: defaultScale(20),
  },
  preDiscountValue: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.GREY_FIGMA_MEDIUM_LIGHT,
    textDecorationLine: 'line-through',
  },
});
